/* ==========================================================================
   VELDR Raíz — comportamiento
   Vanilla, sin librerías. Cada init comprueba si su elemento existe.
   ========================================================================== */
(function () {
  'use strict';

  document.documentElement.classList.add('vr-js');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- reveals */
  function initReveals() {
    var els = document.querySelectorAll('.vr-reveal:not(.vr-visible)');
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vr-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('vr-visible');
        obs.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) {
      // Escalonado automático entre hermanos directos
      if (!el.style.getPropertyValue('--vr-retraso')) {
        var padre = el.parentElement;
        if (padre && padre.children.length > 1) {
          var idx = Array.prototype.indexOf.call(padre.children, el);
          el.style.setProperty('--vr-retraso', Math.min(idx, 6) * 80 + 'ms');
        }
      }
      obs.observe(el);
    });

    // Red de seguridad: si algo impide que el observador dispare, mostrar todo
    setTimeout(function () {
      document.querySelectorAll('.vr-reveal:not(.vr-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('vr-visible');
      });
    }, 1600);
  }

  /* ----------------------------------------------------------------- cifras */
  function initCifras() {
    var els = document.querySelectorAll('[data-vr-cifra]');
    if (!els.length) return;

    function anima(el) {
      var destino = parseFloat(el.getAttribute('data-vr-cifra'));
      var dec = parseInt(el.getAttribute('data-vr-decimales') || '0', 10);
      if (isNaN(destino)) return;
      if (reduce) { el.textContent = destino.toFixed(dec).replace('.', ','); return; }

      var dur = 1500, t0 = null;
      function paso(t) {
        if (t0 === null) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (destino * eased).toFixed(dec).replace('.', ',');
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) { els.forEach(anima); return; }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        anima(e.target);
        obs.unobserve(e.target);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* --------------------------------------------------------------- acordeón */
  function cierraItem(item) {
    var panel = item.querySelector('.vr-acordeon__panel');
    var btn = item.querySelector('.vr-acordeon__btn');
    if (!panel) return;
    panel.style.height = panel.scrollHeight + 'px';
    requestAnimationFrame(function () { panel.style.height = '0px'; });
    item.setAttribute('data-abierto', 'false');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function abreItem(item) {
    var panel = item.querySelector('.vr-acordeon__panel');
    var btn = item.querySelector('.vr-acordeon__btn');
    if (!panel) return;
    panel.style.height = panel.scrollHeight + 'px';
    item.setAttribute('data-abierto', 'true');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    panel.addEventListener('transitionend', function fin(e) {
      if (e.propertyName !== 'height') return;
      if (item.getAttribute('data-abierto') === 'true') panel.style.height = 'auto';
      panel.removeEventListener('transitionend', fin);
    });
  }

  function initAcordeon() {
    document.querySelectorAll('.vr-acordeon').forEach(function (ac) {
      var unico = ac.getAttribute('data-unico') !== 'false';
      ac.querySelectorAll('.vr-acordeon__item').forEach(function (item) {
        var btn = item.querySelector('.vr-acordeon__btn');
        var panel = item.querySelector('.vr-acordeon__panel');
        if (!btn || !panel || btn.getAttribute('data-vr-listo') === 'si') return;
        btn.setAttribute('data-vr-listo', 'si');

        if (item.getAttribute('data-abierto') === 'true') {
          panel.style.height = 'auto';
          btn.setAttribute('aria-expanded', 'true');
        } else {
          panel.style.height = '0px';
          btn.setAttribute('aria-expanded', 'false');
        }

        btn.addEventListener('click', function () {
          var abierto = item.getAttribute('data-abierto') === 'true';
          if (unico && !abierto) {
            ac.querySelectorAll('.vr-acordeon__item[data-abierto="true"]').forEach(function (otro) {
              if (otro !== item) cierraItem(otro);
            });
          }
          if (abierto) { cierraItem(item); } else { abreItem(item); }
        });
      });
    });
  }

  /* ----------------------------------------------------------------- escena */
  function initEscena() {
    document.querySelectorAll('[data-vr-escena]').forEach(function (escena) {
      var pasos = escena.querySelectorAll('.vr-escena__paso');
      var capas = escena.querySelectorAll('.vr-escena__capa');
      var barra = escena.querySelector('.vr-escena__barra');
      if (!pasos.length || !capas.length) return;

      function activar(i) {
        pasos.forEach(function (p, n) { p.setAttribute('data-activo', n === i ? 'true' : 'false'); });
        capas.forEach(function (c, n) { c.setAttribute('data-activa', n === i ? 'true' : 'false'); });
        if (barra) barra.style.width = ((i + 1) / pasos.length * 100) + '%';
      }

      // En móvil la escena degrada a lista: cada paso enseña su propia foto
      if (window.matchMedia('(max-width: 989px)').matches) {
        capas.forEach(function (c) { c.setAttribute('data-activa', 'true'); });
        pasos.forEach(function (p) { p.setAttribute('data-activo', 'true'); });
        return;
      }

      activar(0);
      if (!('IntersectionObserver' in window)) return;

      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = Array.prototype.indexOf.call(pasos, e.target);
          if (i > -1) activar(i);
        });
      }, { threshold: 0.5, rootMargin: '-20% 0px -20% 0px' });
      pasos.forEach(function (p) { obs.observe(p); });
    });
  }

  /* ---------------------------------------------------------------- galería */
  function initGaleria() {
    document.querySelectorAll('[data-vr-galeria]').forEach(function (g) {
      var fotos = g.querySelectorAll('.vr-galeria__foto');
      var tiras = g.querySelectorAll('.vr-galeria__tira');
      var principal = g.querySelector('.vr-galeria__principal');
      if (!fotos.length || !principal) return;

      var actual = 0;
      function ir(i) {
        actual = i;
        fotos.forEach(function (f, n) { f.setAttribute('data-activa', n === i ? 'true' : 'false'); });
        tiras.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      }
      tiras.forEach(function (t, i) {
        t.addEventListener('click', function () { ir(i); });
      });

      // Deslizar con el dedo
      var x0 = null;
      principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      principal.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) {
          ir((actual + (dx < 0 ? 1 : -1) + fotos.length) % fotos.length);
        }
        x0 = null;
      }, { passive: true });
    });
  }

  /* --------------------------------------------------------------- cabecera */
  function initCabecera() {
    var h = document.querySelector('.vr-header');
    if (!h) return;

    function mide() {
      document.documentElement.style.setProperty('--vr-cabecera', h.offsetHeight + 'px');
    }
    mide();
    window.addEventListener('resize', mide);

    var ultimo = 0;
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      if ((y > 8) !== (ultimo > 8)) h.setAttribute('data-scroll', y > 8 ? 'true' : 'false');
      ultimo = y;
    }, { passive: true });

    var burger = h.querySelector('.vr-burger');
    var panel = document.querySelector('.vr-panel-movil');
    if (!burger || !panel || burger.getAttribute('data-vr-listo') === 'si') return;
    burger.setAttribute('data-vr-listo', 'si');

    function cierraPanel() {
      panel.setAttribute('data-abierto', 'false');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    burger.addEventListener('click', function () {
      var abierto = panel.getAttribute('data-abierto') === 'true';
      if (abierto) { cierraPanel(); return; }
      panel.setAttribute('data-abierto', 'true');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
    panel.querySelectorAll('a, [data-vr-cerrar]').forEach(function (a) {
      a.addEventListener('click', cierraPanel);
    });
  }

  /* ---------------------------------------------------------------- anclajes
     Shopify antepone el id interno de la plantilla a los ids de sección, así
     que un href="#mi-seccion" no encuentra nada. Resolvemos por el atributo
     data-vr-ancla y compensamos la altura de la cabecera pegajosa. */
  function initAnclajes() {
    if (document.documentElement.getAttribute('data-vr-anclajes') === 'si') return;
    document.documentElement.setAttribute('data-vr-anclajes', 'si');

    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href*="#"]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var almo = href.indexOf('#');
      if (almo < 0) return;

      // Aceptamos "#seccion" y también "/#seccion" cuando ya estamos en la portada,
      // que es como quedan los enlaces del menú y del pie.
      var ruta = href.slice(0, almo);
      if (ruta && ruta !== '/' && ruta !== location.pathname) return;
      if (ruta === '/' && location.pathname !== '/') return;

      var clave = href.slice(almo + 1);
      if (!clave) return;
      var destino = document.querySelector('[data-vr-ancla="' + clave + '"]');
      if (!destino) return;
      e.preventDefault();
      var h = document.querySelector('.vr-header');
      var offset = (h ? h.offsetHeight : 0) + 12;
      var y = destino.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  /* ------------------------------------------------------------- barra fija
     El botón de la barra es un <button form="..."> nativo: envía el formulario
     real del producto sin que el guion tenga que simular ninguna pulsación.
     Aquí solo copiamos el estado de agotado y decidimos cuándo se ve. */
  function initBarraFija() {
    var barra = document.querySelector('[data-vr-barra-fija]');
    if (!barra) return;
    var testigo = document.querySelector('[data-vr-testigo-compra]');
    var boton = document.querySelector('[data-vr-boton-real]');
    var btnBarra = barra.querySelector('button');

    function sincroniza() {
      if (!boton || !btnBarra) return;
      var bloqueado = boton.disabled || boton.getAttribute('aria-disabled') === 'true';
      btnBarra.disabled = bloqueado;
      // Copiamos el texto del botón real para no inventarnos el motivo
      // (puede ser "Agotado" o "No disponible" según el caso).
      btnBarra.textContent = bloqueado
        ? boton.textContent.trim()
        : (btnBarra.getAttribute('data-texto') || 'Añadir');
    }
    sincroniza();
    if (boton && 'MutationObserver' in window) {
      new MutationObserver(sincroniza).observe(boton, { attributes: true, childList: true, subtree: true });
    }

    if (!testigo || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        barra.setAttribute('data-visible', e.isIntersecting ? 'false' : 'true');
      });
    }, { threshold: 0 }).observe(testigo);
  }

  /* --------------------------------------------------------------- variantes
     Cuando hay más de una variante, el desplegable manda el id al formulario
     de forma nativa. Aquí solo refrescamos el precio que se ve en pantalla. */
  function initVariantes() {
    var sel = document.querySelector('[data-vr-selector-variante]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var opcion = sel.options[sel.selectedIndex];
      if (!opcion) return;
      var precio = opcion.getAttribute('data-precio');
      if (!precio) return;
      document.querySelectorAll('[data-vr-precio]').forEach(function (el) {
        el.textContent = precio;
      });
    });
  }

  /* --------------------------------------------------------------- parallax */
  function initParallax() {
    if (reduce) return;
    var els = document.querySelectorAll('[data-vr-parallax]');
    if (!els.length) return;

    var tick = false;
    function pinta() {
      els.forEach(function (el) {
        var f = parseFloat(el.getAttribute('data-vr-parallax')) || 0.12;
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
        var centro = r.top + r.height / 2 - window.innerHeight / 2;
        el.style.transform = 'translate3d(0,' + (-centro * f).toFixed(1) + 'px,0)';
      });
      tick = false;
    }
    window.addEventListener('scroll', function () {
      if (tick) return;
      tick = true;
      requestAnimationFrame(pinta);
    }, { passive: true });
    pinta();
  }

  /* ------------------------------------------------------------------ marcha */
  function arranca() {
    initCabecera();
    initReveals();
    initCifras();
    initAcordeon();
    initEscena();
    initGaleria();
    initAnclajes();
    initVariantes();
    initBarraFija();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }

  // El editor de Shopify recarga secciones sueltas: hay que reinicializar
  document.addEventListener('shopify:section:load', arranca);
})();
